import { call, put } from 'redux-saga/effects';
import { RescanFileAction } from '../types';
import { ApiResponse } from 'store/api/types';
import { rescanReceipt } from '../api';
import { checkResponse } from 'store/utils';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import {
  fetchAllExcelTransactionsRequest,
  fetchExcelFilesMetadataRequest,
  fetchLastReceiptUploadStatusRequest,
  updateEntityGroupFailure,
  uploadReceiptSuccess,
} from '../actions';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

export function* rescanReceiptSaga(action: RescanFileAction) {
  try {
    const { organisationId, fileId, grouped } = action.payload;

    const response: ApiResponse = yield call(
      rescanReceipt,
      organisationId,
      fileId,
      grouped
    );

    const err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const batchId: string | undefined = (response as any)?.data?.batchId;
    if (batchId) {
      yield put(uploadReceiptSuccess(batchId));
    }
    yield put(fetchLastReceiptUploadStatusRequest(organisationId));
    yield put(fetchExcelFilesMetadataRequest(organisationId));
    yield put(fetchAllExcelTransactionsRequest(organisationId, 1, 10));

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.rescanning-receipt-in-progress'),
      type: MessageStates.INFO,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }

    yield put(updateEntityGroupFailure());
  }
}
